import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const CASES = [
  {
    id: "barbershop",
    name: "Nordic Fade",
    industry: "Barbershop",
    text: "Et moderne websitekoncept til en lokal barbershop med fokus på booking, services og et stærkt visuelt udtryk.",
    note: "Konceptprojekt – ikke en rigtig kunde.",
    tags: ["Online booking", "Services & priser", "Galleri"],
    image:
      "https://images.unsplash.com/photo-1585747860715-2ba37e788b70?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    link: "/cases/barbershop",
  },
  {
    id: "cleaning",
    name: "RenBy København",
    industry: "Rengøringsfirma",
    text: "En lys og tillidsvækkende side, hvor besøgende hurtigt kan få et uforpligtende tilbud på rengøring.",
    note: "Konceptprojekt – ikke en rigtig kunde.",
    tags: ["Tilbudsformular", "Kundeanmeldelser", "SEO"],
    image:
      "https://images.unsplash.com/photo-1758523670739-0d26a3ee976d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    link: "/cases/renby",
  },
  {
    id: "autorepair",
    name: "Apex Auto",
    industry: "Autoværksted",
    text: "En direkte og professionel side, hvor bilejere nemt kan booke tid til service, dækskift eller syn.",
    note: "Konceptprojekt – ikke en rigtig kunde.",
    tags: ["Tidsbestilling", "Serviceoversigt", "Google Maps"],
    image:
      "https://images.unsplash.com/photo-1676018366904-c083ed678e60?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    link: "/cases/apex-auto",
  },
];

export const Cases = () => (
  <section id="cases" className="py-20 sm:py-28" data-testid="cases-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-zinc-500 mb-4">
          Cases
        </p>
        <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-zinc-900 max-w-2xl">
          Sådan kan din nye hjemmeside se ud
        </h2>
        <p className="mt-4 text-base sm:text-lg text-zinc-600 max-w-2xl">
          Projekterne herunder er{" "}
          <span className="font-semibold text-zinc-900">konceptprojekter</span> — ikke
          rigtige kunder. De viser vores stil og, hvad vi kan lave for din branche.
        </p>
      </Reveal>

      <div className="mt-14 grid gap-8 md:grid-cols-2 lg:grid-cols-3">
        {CASES.map((c, i) => (
          <Reveal key={c.id} delay={i * 0.12}>
            <article
              data-testid={`case-card-${c.id}`}
              className="group h-full flex flex-col bg-white border border-zinc-200/80 rounded-2xl overflow-hidden hover:border-zinc-900 hover:-translate-y-1 transition-all duration-300"
            >
              <div className="relative aspect-[4/3] overflow-hidden bg-zinc-100">
                <img
                  src={c.image}
                  alt={`Konceptprojekt for ${c.industry.toLowerCase()}: ${c.name}`}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute top-4 left-4 text-[11px] font-semibold uppercase tracking-[0.15em] bg-white/90 backdrop-blur px-3 py-1.5 rounded-full text-zinc-700">
                  Konceptprojekt
                </span>
              </div>
              <div className="flex flex-col flex-1 p-7">
                <p className="text-xs font-medium uppercase tracking-[0.15em] text-zinc-500">
                  {c.industry}
                </p>
                <h3 className="mt-2 text-xl font-semibold text-zinc-900">{c.name}</h3>
                <p className="mt-3 text-sm text-zinc-600 leading-relaxed flex-1">{c.text}</p>
                {c.note && (
                  <p className="mt-3 text-xs font-medium text-zinc-500 italic">{c.note}</p>
                )}
                <div className="mt-5 flex flex-wrap gap-2">
                  {c.tags.map((t) => (
                    <span
                      key={t}
                      className="text-xs font-medium bg-zinc-100 text-zinc-600 rounded-full px-3 py-1"
                    >
                      {t}
                    </span>
                  ))}
                </div>
                {c.link && (
                  <Link
                    to={c.link}
                    data-testid={`case-cta-${c.id}`}
                    className="mt-6 inline-flex w-fit items-center gap-2 bg-zinc-900 text-white text-sm font-medium rounded-full px-6 py-3 hover:bg-zinc-700 hover:-translate-y-0.5 transition-all duration-200"
                  >
                    Se projektet
                    <ArrowRight className="w-4 h-4" aria-hidden="true" />
                  </Link>
                )}
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
